export const inventa_contact_email = 'atendimento@inventa.shop';
